// Simple UUID generator that doesn't rely on external packages
export const generateUuid = (): string => {
  // Create random hex strings
  const s4 = () => {
    return Math.floor((1 + Math.random()) * 0x10000)
      .toString(16)
      .substring(1);
  };
  
  // Format: xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx
  // Where y is one of: 8, 9, A, or B
  return (
    s4() + s4() + '-' + 
    s4() + '-' + 
    '4' + s4().substring(0, 3) + '-' + 
    (Math.floor(Math.random() * 4) + 8).toString(16) + s4().substring(0, 3) + '-' + 
    s4() + s4() + s4()
  );
}; 